<script>

    import { location, link, replace } from 'svelte-spa-router'
    import { UserStore } from '../stores'

    import LocalstoreService from '../localstore'

    import Dropdown from '../$components/dropdown.svelte'
    import WalletAmount from '../wallets/wallet.amount.svelte'

    function onDropdownSelected(event) {

        const value = event.detail

        if(value === 'logout') {
            LocalstoreService.deleteItem('user')
            LocalstoreService.deleteItem('session')
            UserStore.set(null)
            return replace('#/login')
        }
    }

</script>

<style>
    .navbar {
        border-bottom: solid 1px #F2E612 !important;
    }
</style>

<div class="items space navbar">
    <a class="navbar-item" href="/#/shipments">
        <img src="/images/brand.png" alt="Brand" style="max-height: none; max-width: 50px;">
    </a>
    <div class="items end">
        <a href="/informations/credits" use:link class="button is-light">
            <span class="icon"><i class="fas fa-wallet"></i></span>
            <span>
                <WalletAmount />
            </span>
        </a>
        {#if $UserStore}
            <Dropdown on:change={ onDropdownSelected } text={$UserStore.name} icon="user" color="white" options={[
                {value: 'logout', text: 'Cerrar sesión'}
            ]} />
        {/if}
    </div>
</div>

<div class="tabs is-centered">
    <ul>
        <li class:is-active={$location.includes('/quotations')}>
            <a href="/quotations" use:link>
                <span class="icon"><i class="fas fa-calculator"></i></span>
                <span>Cotización</span>
            </a>
        </li>
        <li class:is-active={$location.includes('/shipments')}>
            <a href="/shipments" use:link>
                <span class="icon"><i class="fas fa-truck"></i></span>
                <span>Envíos</span>
            </a>
        </li>
        <li class:is-active={$location === '/pickups'}>
            <a href="/pickups" use:link>
                <span class="icon"><i class="fas fa-truck-loading"></i></span>
                <span>Recolecciones</span>
            </a>
        </li>
        <li class:is-active={$location === '/tickets'}>
            <a href="/tickets" use:link>
                <span class="icon"><i class="fas fa-ticket-alt"></i></span>
                <span>Tickets</span>
            </a>
        </li>
        <li class:is-active={$location.includes('/informations')}>
            <a href="/informations" use:link>
                <span class="icon"><i class="fas fa-info-circle"></i></span>
                <span>Información</span>
            </a>
        </li>
        <li class:is-active={$location.includes('/settings')}>
            <a href="/settings" use:link>
                <span class="icon"><i class="fas fa-cog"></i></span>
                <span>Configuración</span>
            </a>
        </li>
    </ul>
</div>